<p-table
  dataKey="name"
  [value]="categories"
  [(selection)]="selectedCategories"
  [tableStyle]="{ 'min-width': '50rem' }">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th style="width: 1rem"></th>
      <th>Themenbereich</th>
      <th>Read / Write</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-category>
    <tr>
      <td>
        <p-tableCheckbox [value]="category"></p-tableCheckbox>
      </td>
      <td><i class="fas fa-note-sticky"></i></td>
      <td>{{ category.name }}</td>
      <td><p-inputSwitch (click)="accessToggle()"></p-inputSwitch></td>
    </tr>
  </ng-template>
</p-table>
